module.exports = __webpack_public_path__ + "static/media/2 (45).6d107795.jpg";